import React from 'react';
import McqSingleAnswer from './mcq-single-answer';

export default class QuestionLayout extends React.Component<any, any> {
  constructor(props) {
    super(props);
  }

  renderQuestionBankLayout = () => {
    let components = null;
    switch (this.props.question.question_type) {
      // Speaking
      case 'MCQ_L_SINGLE_ANSWER':
        components = (
          <McqSingleAnswer
            key={this.props.question._id}
            { ...this.props }
          />
        );
        break;
      default:
        <div>
          <span>Component not found</span>
        </div>;
        break;
    }

    return components;
  };

  render() {
    let elements = this.renderQuestionBankLayout();
    return <div>{elements}</div>;
  }
}
